export default __webpack_public_path__ + "static/media/chatLogo.497444e0.jpeg";